var ACFilterTypes = /** @class */ (function () {
    function ACFilterTypes() {
        this.types = [];
    }
    ACFilterTypes.prototype.addType = function (type) {
        this.types.push(type);
    };
    ACFilterTypes.prototype.hasType = function (type) {
        return this.types.filter(function (t) { return t.filter_type === type; });
    };
    ACFilterTypes.prototype.getType = function (type) {
        return this.types.find(function (t) { return t.filter_type === type; });
    };
    ACFilterTypes.prototype.getTypes = function () {
        return this.types;
    };
    return ACFilterTypes;
}());
export default ACFilterTypes;
